import 'rxjs/add/operator/debounceTime';
import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TFieldType, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {WebstorService} from "../../../providers/webstor-service";
import {
    TAction,
    THotpageAnimate,
    THotpageContent,
    THotpageFeedback,
    THotpageHistoria,
    THotpageLogotype,
} from "../../../app/enum";
import {WebsiteSpotPage} from "../website-spot/website-spot";
import {ModalFieldPage} from "../modal-field/modal-field";
import {ModalActionPage} from "../modal-action/modal-action";


@Component({
    selector: 'page-branded-html',
    templateUrl: 'branded-html.html',
    providers: [WebstorService]
})
export class BrandedHtmlPage {

    THotpageContent: any = THotpageContent;
    THotpageAnimate: any = THotpageAnimate;
    THotpageLogotype: any = THotpageLogotype;
    THotpageHistoria: any = THotpageHistoria;
    THotpageFeedback: any = THotpageFeedback;

    config: any;
    logado: any;
    perfil: any;

    rootbran: any;
    copybran: any;

    template: number = 0;

    constructor(public navCtrl: NavController, public navParams: NavParams, public util: Util,
                public logadoService: LogadoService, public webstorService: WebstorService) {

        this.config = CONFIG;

        this.logado = this.logadoService.getAuth();
        this.perfil = this.navParams.get('perfil');

        this.rootbran = this.navParams.get('rootbran');
        this.copybran = this.navParams.get('copybran');

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    brandedSave(that: any = null, reset?) {

        let template = this.copybran.BrandedBody.Hspot;
        if (reset) template = null;

        if (!template.Layoute && !template.Layoute64) {
            //this.util.populateObj(this.copybran, this.rootbran);
            //this.util.alertSimply('Informe o Layout para iniciar a configuração');
            //return;
        }

        let json = this.copybran.BrandedBody;

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.branded(TAction.acHtml, this.copybran.BrandedID, 0, 0, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    this.rootbran.BrandedBody.Hspot = this.util.deepCopy(template);
                    if (that) that.dismiss();

                },
                erro => {

                    template = this.util.deepCopy(this.rootbran.BrandedBody.Hspot);
                    this.util.alertResult(erro);

                });

    }

    hplate(): any {

        return this.copybran.BrandedBody.Hspot;

    }

    platenode(blocked, rootname: 'Header' | 'Resume' | 'Button' | 'Spacer' | 'Ground', rootnome: 'Corone' | 'Cortwo' | 'Fonted' | 'Weight' | 'Textod' | 'Molded' | 'Fill' | 'Size' | 'Clip' | 'Shape' | 'Estilo' | 'Height' | 'Imaged' | 'Movied', rootfile: 'Source' | 'Opacit' | 'Scroll' | ' Grayed' = null, tag: number = 0, hpage: any = null, meritum: any = null): any {

        return this.config.platenode(this.copybran, blocked, rootname, rootnome, rootfile, tag, hpage, meritum);

    }

    hotspotPage() {

        let brandex = this.copybran;
        let hotspotID = this.copybran.HotspotID;
        let object = {hotspotID: hotspotID, brandex: brandex, tabmenu: false};
        this.navCtrl.push(WebsiteSpotPage, object);

    }

    templategroup(indexGroup, indexBlock) {

        let template = this.copybran.BrandedBody.Hspot;

        //Moving To-root
        if (indexBlock) {
            let blocked = {Array: [template.Array[indexGroup].Array[indexBlock]]};
            template.Array[indexGroup].Array.splice(indexBlock, 1);
            template.Array.splice(indexGroup + 1, 0, blocked);
            this.brandedSave(null);
        }

        //Insert Children
        if (!indexBlock) {

            /** SHOW **/
            let onSave = (type) => {
                let finded = null;
                template.Array.forEach((group, indexG) => {
                    group.Array.forEach((block, indexB) => {
                        if (block.Content == type) finded = {block: block, indexG: indexG, indexB: indexB};
                    });
                });

                if (finded.indexB == 0 && template.Array[finded.indexG].Array.length > 1) {
                    this.util.toastSimply('Existe filhos...');
                    return;
                }

                template.Array[indexGroup].Array.push(finded.block);
                if (finded.indexB == 0) template.Array.splice(finded.indexG, 1);
                if (finded.indexB  > 0) template.Array[finded.indexG].Array.splice(finded.indexB, 1);
                this.brandedSave(null);
            };

            /** OPEN **/
            let buttons: Array<any> = [];
            let side = this.config.plateobject(null).Inside;
            let line = side.find(base => base.group == template.Array[indexGroup].Array[0].Content);
            line.array.forEach(insert => {
                let bool = !template.Array[indexGroup].Array.find(base => base.Content == insert);
                if (bool) buttons.push({text: THotpageContent[insert].slice(2, 99), handler: () => onSave(insert)});
            });
            this.util.sheetOpen(buttons, 'INSERT');
        }

    }

    modalGroup(type: TFieldType, title, rootname, rootnome, rootfile, blocked, arrey, limit: any = null): any {
        let array = arrey;

        if ([TFieldType.ftPicker, TFieldType.ftSheet, TFieldType.ftRadio, TFieldType.ftPutin].indexOf(type) >= 0) {
            array = [];
            arrey.forEach((flag, index) => array[index] = this.config.modalChild(flag, flag, null));
        }

        let file = (rootnome == 'Molded' || rootnome == 'Imaged' || rootnome == 'Movied');
        let value = blocked[rootname][rootnome];
        if (file && value) value = value[rootfile];
        if ([TFieldType.ftPicker, TFieldType.ftSheet, TFieldType.ftRadio, TFieldType.ftCheck, TFieldType.ftPutin, TFieldType.ftColor].indexOf(type) >= 0) {
            value = this.platenode(blocked, rootname, rootnome, rootfile);
        }

        let texto = null;
        let filer = null;
        if (file) {
            let bann = (blocked.Content == THotpageContent.hcBanner);
            let type = (bann || rootnome == 'Molded' ? 'image/png' : (rootnome == 'Movied' ? 'video/mp4' : 'image/jpeg'));
            texto = (bann || rootnome == 'Molded' ? 'PNG file.' : (rootnome == 'Movied' ? 'MP4 file.' : 'JPG file.'));
            filer = {acceptTypes: type, sizebyte: ((10.0 * 1024) * 1024), selectLimit: 1, width: (rootnome == 'Movied' ? 0 : 2560), height: 0};
        }

        //Pre-Pos Caracters...
        if (rootfile == 'Opacit') value = (value * 100) + '%';
        if (rootnome == 'Height') value = (value == '0' ? 'None' : value + 'px');

        let field = this.config.modalField(type, title, texto, limit, value, array, filer);
        return this.config.modalGroup(null, [field]);
    };

    templateanime(indexGroup, indexBlock, indox, anime?) {

        let blockedx = this.copybran.BrandedBody.Hspot.Array[indexGroup].Array[indexBlock];

        /** LIXO **/
        let onDisable = () => {
            blockedx.Animate.splice(indox, 1);
            this.brandedSave(null);
        };

        /** OPEN **/
        if (!anime) {
            let flag = (indox == 0 ? 1 : 0);
            let fleg = (!blockedx.Animate[indox] ? THotpageAnimate.haDefault : blockedx.Animate[indox].Tipo);
            let tipo = (!blockedx.Animate[flag]  ? THotpageAnimate.haDefault : blockedx.Animate[flag].Tipo);

            let buttons: Array<any> = [];
            if (tipo != THotpageAnimate.haBlocki) buttons.push({text: 'Blocke', cssClass: this.util.sheetClass(fleg, THotpageAnimate.haBlocki), handler: () => this.templateanime(indexGroup, indexBlock, indox, THotpageAnimate.haBlocki)});
            if (tipo != THotpageAnimate.haEntire) buttons.push({text: 'Entire', cssClass: this.util.sheetClass(fleg, THotpageAnimate.haEntire), handler: () => this.templateanime(indexGroup, indexBlock, indox, THotpageAnimate.haEntire)});
            if (tipo != THotpageAnimate.haValued) buttons.push({text: 'Valued', cssClass: this.util.sheetClass(fleg, THotpageAnimate.haValued), handler: () => this.templateanime(indexGroup, indexBlock, indox, THotpageAnimate.haValued)});
            if (tipo != THotpageAnimate.haHeader) buttons.push({text: 'Header', cssClass: this.util.sheetClass(fleg, THotpageAnimate.haHeader), handler: () => this.templateanime(indexGroup, indexBlock, indox, THotpageAnimate.haHeader)});
            if (tipo != THotpageAnimate.haButton) buttons.push({text: 'Button', cssClass: this.util.sheetClass(fleg, THotpageAnimate.haButton), handler: () => this.templateanime(indexGroup, indexBlock, indox, THotpageAnimate.haButton)});
            if (tipo != THotpageAnimate.haGround) buttons.push({text: 'Ground', cssClass: this.util.sheetClass(fleg, THotpageAnimate.haGround), handler: () => this.templateanime(indexGroup, indexBlock, indox, THotpageAnimate.haGround)});
            buttons.push({text: 'Disable', handler: () => onDisable(), role: 'destructive'});
            this.util.sheetOpen(buttons, 'ANIMATE');
            return;
        }

        let onOkiy = (that, okiy, index, isLast) => {

            if (!blockedx.Animate) blockedx.Animate = [];
            if (indox == 1 && blockedx.Animate.length == 0) indox = 0;

            if (!blockedx.Animate[indox]) blockedx.Animate.push({Tipo: THotpageAnimate.haDefault, Name: ''});
            blockedx.Animate[indox].Tipo = anime;
            blockedx.Animate[indox].Name = okiy[0].groups[0].fields[0].value;

            this.brandedSave(that);

        };

        let name = (blockedx.Animate[indox] ? blockedx.Animate[indox].Name : '');
        this.util.modalopen(ModalFieldPage, 'quad', true, {window: 'Animate', select: name, slides: null, onOkiy: onOkiy}).subscribe();

    }

    templatetitle(keyname, orderby?) {

        let template = this.copybran.BrandedBody.Hspot;

        //Change Orderby
        if (orderby) {
            let from = orderby.from;
            let toto = orderby.to;

            let item = template.Array[from];
            template.Array.splice(from, 1);
            template.Array.splice(toto, 0, item);
            this.brandedSave(null);
            return;
        }

        //CSS Custom
        if (keyname == 'Stylecss') {
            let onOkiy = (that, okiy, index, isLast) => {
                template.Stylecss = okiy[0].groups[0].fields[0].value;
                this.brandedSave(that);
            };

            let fieldHtml = this.config.modalField(TFieldType.ftText, null, null, null, template.Style, null, null);
            let groupHtml = this.config.modalGroup(null, [fieldHtml]);
            let slideHtml = this.config.modalSlide('CSS Custom', null, null, null, 'CorRoxa', [groupHtml]);

            this.util.modalopen(ModalFieldPage, 'quad', false, {slides: [slideHtml], onOkiy: onOkiy}).subscribe();
            return;
        }

        //Change Template-Config
        if (keyname == 'Spotify') {
            let onOkey = (okey, that, data) => {
                template.Spotify = okey.inputf.text;
                this.brandedSave(that);
            };

            let objectData = {modalinfo: this.config.modalinfo(this.util, 'spotify', onOkey)};
            this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();
            return;
        }

        //Change Template-Config
        if (keyname == 'Layoute' || keyname == 'Logotipo' || keyname == 'Logotint' || keyname == 'Logotype' || keyname == 'Historia' || keyname == 'Feedback') {

            let onSave = (type, that?) => {
                template[keyname] = type;
                console.log(template);
                this.brandedSave(that);
            };

            let onTint = () => {

                let onOkiy = (that, okiy, index, isLast) => onSave(okiy[0].groups[0].fields[0].value, that);

                /** COLOR **/
                let colorList: any[] = [];
                for (let color in this.config.colors) colorList.push({title: color, value: color});

                //let itemsInfo = this.config.modalChild('CorMenu', 'CorMenu', null);
                let fieldInfo = this.config.modalField(TFieldType.ftColor, null, null, null, null, colorList, null);
                let groupInfo = this.config.modalGroup(null, [fieldInfo]);
                let slideInfo = this.config.modalSlide('Pintura', 'Vamos pintar?', 'Selecione uma cor!', 'b-icon-brush', 'CorRoxa', [groupInfo]);

                this.util.modalopen(ModalFieldPage, 'quad', false, {slides: [slideInfo], onOkiy: onOkiy}).subscribe();

            };

            let onFile = () => {

                let optionsJpg = {acceptTypes: 'image/jpeg', sizebyte: (6 * (1024 * 1024)), selectLimit: 0, minmax: 'FIX', width: 2560, height: 0, quality: 100};
                this.util.fileSelect(optionsJpg).subscribe(
                    base => {

                        template.Layoute = this.config.paths.httpStorage + '/hotpage/' + this.copybran.BrandedID + '/layoute.jpg?' + Math.random();
                        template.Layoute64 = base[0].base64.split(',')[1];
                        this.brandedSave();

                    },

                    erro => this.util.alertResult(erro)
                );

            };


            /** OPEN **/
            let value = template[keyname];
            let buttons: Array<any> = [];
            if (keyname == 'Layoute') {
                buttons.push({text: 'Visualizar',  handler: () => this.util.open(template.Layoute, '_blank')});
                buttons.push({text: 'Selecionar',  handler: () => onFile()});
            }
            if (keyname == 'Logotipo') {
                buttons.push({text: 'Logo',                        handler: () => onSave(null)});
                buttons.push({text: 'Icon',                        handler: () => onSave('#Icon')});
            }
            if (keyname == 'Logotint') {
                buttons.push({text: 'Original',                        handler: () => onSave(null)});
                buttons.push({text: 'BrandCor',                        handler: () => onSave('#Corone')});
                buttons.push({text: 'Select',                          handler: () => onTint()});
            }
            if (keyname == 'Logotype') {
                buttons.push({text: 'Default',  cssClass: this.util.sheetClass(value, THotpageLogotype.hlDefault),  handler: () => onSave(THotpageLogotype.hlDefault)});
                buttons.push({text: 'Action',   cssClass: this.util.sheetClass(value, THotpageLogotype.hlAction),   handler: () => onSave(THotpageLogotype.hlAction)});
                buttons.push({text: 'Banner',   cssClass: this.util.sheetClass(value, THotpageLogotype.hlBanner),   handler: () => onSave(THotpageLogotype.hlBanner)});
            }
            if (keyname == 'Historia') {
                buttons.push({text: 'Hidden',   cssClass: this.util.sheetClass(value, THotpageHistoria.hhHidden),   handler: () => onSave(THotpageHistoria.hhHidden)});
                buttons.push({text: 'Logotipo', cssClass: this.util.sheetClass(value, THotpageHistoria.hhLogotipo), handler: () => onSave(THotpageHistoria.hhLogotipo)});
                buttons.push({text: 'Social',   cssClass: this.util.sheetClass(value, THotpageHistoria.hhSocial),   handler: () => onSave(THotpageHistoria.hhSocial)});
                buttons.push({text: 'Place',    cssClass: this.util.sheetClass(value, THotpageHistoria.hhPlace),    handler: () => onSave(THotpageHistoria.hhPlace)});
                buttons.push({text: 'Brand',    cssClass: this.util.sheetClass(value, THotpageHistoria.hhBranded),  handler: () => onSave(THotpageHistoria.hhBranded)});
                buttons.push({text: 'Usuário',  cssClass: this.util.sheetClass(value, THotpageHistoria.hhUsuario),  handler: () => onSave(THotpageHistoria.hhUsuario)});
            }
            if (keyname == 'Feedback') {
                buttons.push({text: 'Hidden',   cssClass: this.util.sheetClass(value, THotpageFeedback.hfHidden),   handler: () => onSave(THotpageFeedback.hfHidden)});
                buttons.push({text: 'Logotipo', cssClass: this.util.sheetClass(value, THotpageFeedback.hfLogotipo), handler: () => onSave(THotpageFeedback.hfLogotipo)});
                buttons.push({text: 'Social',   cssClass: this.util.sheetClass(value, THotpageFeedback.hfSocial),   handler: () => onSave(THotpageFeedback.hfSocial)});
                buttons.push({text: 'Checkin',  cssClass: this.util.sheetClass(value, THotpageFeedback.hfCheckin),  handler: () => onSave(THotpageFeedback.hfCheckin)});
            }
            this.util.sheetOpen(buttons, keyname.toUpperCase());
        }

    }

    templatelayout(blocked) {

        /** EDIT **/
        let onSelect = (layoute: number) => {
            blocked.Layoute = layoute;
            this.brandedSave(null);
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        let array = this.config.plateobject(null).Layout[blocked.Content];
        array.forEach((txt, idx) => buttons.push({text: txt, cssClass: this.util.sheetClass(blocked.Layoute, idx + 1), handler: () => onSelect(idx + 1)}));
        buttons.push({text: 'Disable', handler: () => onSelect(0), role: 'destructive'});

        /** OPEN **/
        this.util.sheetOpen(buttons, 'LAYOUT', 2, (blocked.Layoute == 0 ? 0 : 1));

    }

    templatesheet(rootname, blockedx) {

        let onDefine = (keyname, koyname?, value: string = null) => {
            if (keyname) blockedx[rootname][keyname] = value;
            if (koyname) blockedx[rootname][koyname] = value;
            this.brandedSave();
        };

        let onlypc = () => {
            //blockedx[rootname].Onlypc = this.platesaveed(blockedx, rootname, 'Onlypc', null, 0, blockedx[rootname].Onlypc);
            this.brandedSave();
        };

        let onImage = () => {
            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Symb',   handler: () => this.templatemodal('Image', '#Symb', rootname, blockedx)});
            buttons.push({text: 'Logo',   handler: () => this.templatemodal('Image', '#Logo', rootname, blockedx)});
            buttons.push({text: 'Image',  handler: () => this.templatemodal('Image', null, rootname, blockedx)});
            if (blockedx[rootname].Imaged) buttons.push({text: 'Delete', handler: () => onDefine('Imaged'), role: 'destructive'});
            this.util.sheetOpen(buttons, 'IMAGE');
        };

        let onMovie = () => {
            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Movie',  handler: () => this.templatemodal('Movie', null, rootname, blockedx)});
            buttons.push({text: 'Delete', handler: () => onDefine('Movied'), role: 'destructive'});
            if (blockedx[rootname].Movied) this.util.sheetOpen(buttons, 'MOVIED');
            if (!blockedx[rootname].Movied) buttons[0].handler();
        };

        let onColor = () => {
            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Select', handler: () => this.templatemodal('Color', null, rootname, blockedx)});
            buttons.push({text: 'Corone', handler: () => onDefine('Corone', 'Cortwo', '#Corone')});
            buttons.push({text: 'Cortwo', handler: () => onDefine('Corone', 'Cortwo', '#Cortwo')});
            buttons.push({text: 'Delete', handler: () => onDefine('Corone', 'Cortwo', null), role: 'destructive'});
            this.util.sheetOpen(buttons, 'COLOR');
        };

        let onMolde = () => {
            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Hide',   handler: () => this.templatemodal('Molde', '#Hide', rootname, blockedx)});
            buttons.push({text: 'Symb',   handler: () => this.templatemodal('Molde', '#Symb', rootname, blockedx)});
            buttons.push({text: 'Image',  handler: () => this.templatemodal('Molde', null, rootname, blockedx)});
            if (blockedx[rootname].Imaged) buttons.push({text: 'Delete', handler: () => onDefine('Imaged'), role: 'destructive'});
            this.util.sheetOpen(buttons, 'IMAGE');
        };

        /** OPEN **/
        let buttons: Array<any> = [];

        let txt = (rootname == 'Textod');
        let bcg = (rootname == 'Ground');
        let spc = (rootname == 'Spacer');
        let btn = (rootname == 'Button');
        let mld = (rootname == 'Header' || rootname == 'Resume');
        let fnt = (rootname == 'Header' || rootname == 'Resume' || rootname == 'Button');

        if (bcg)  buttons.push({text: 'Onlypc', handler: () => onlypc()});
        if (bcg)  buttons.push({text: 'Image',  handler: () => onImage()});
        if (bcg)  buttons.push({text: 'Movie',  handler: () => onMovie()});
        if (!txt) buttons.push({text: 'Color',  handler: () => onColor()});
        if (spc)  buttons.push({text: 'Space',  handler: () => this.templatemodal('Space', null, rootname, blockedx)});
        if (btn)  buttons.push({text: 'Botao',  handler: () => this.templatemodal('Botao', null, rootname, blockedx)});
        if (fnt)  buttons.push({text: 'Fonte',  handler: () => this.templatemodal('Fonte', null, rootname, blockedx)});
        if (txt)  buttons.push({text: 'Texto',  handler: () => this.templatemodal('Texto', null, rootname, blockedx)});
        if (mld)  buttons.push({text: 'Molde',  handler: () => onMolde()});

        /** OPEN **/
        this.util.sheetOpen(buttons, rootname.toUpperCase());

    }

    templatemodal(module: 'Image' | 'Movie' | 'Space' | 'Botao' | 'Fonte' | 'Color' | 'Texto' | 'Molde' | 'Delet', action: null | '#Symb' | '#Logo' | '#Hide' = null, rootname, blockedx): any {

        if (module == 'Image' || module == 'Movie') {
            let onOkiy = (that, okiy, index, isLast) => {

                if (this.util.slideNext(that, (index < okiy.length -1))) return;

                let scroll = okiy[0].groups[0].fields[0].value;
                let opacit = parseInt(okiy[0].groups[1].fields[0].value.split('%')[0]) / 100;
                let grayed = okiy[0].groups[2].fields[0].value;
                let adjust = okiy[0].groups[3].fields[0].value;
                let httpsd = this.config.paths.httpStorage + '/hotpage/' + this.copybran.BrandedID + '/' + THotpageContent[blockedx.Content] + '.jpg';
                let source = (['#Symb', '#Logo'].indexOf(action) >= 0 ? action : httpsd);
                let file64 = (['#Symb', '#Logo'].indexOf(action) >= 0 ? action : okiy[0].groups[4].fields[0].value.base64);
                let base64 = (!file64 ? null : file64.indexOf(',') < 0 ? null : file64.split(',')[1]);
                let object = {Source: source, Scroll: scroll, Opacit: opacit, Grayed: grayed, Adjust: adjust, B64: base64};

                if (module == 'Movie') blockedx[rootname].Movied = object;
                if (module == 'Image') blockedx[rootname].Imaged = object;

                this.brandedSave(that);
            };

            /** SLIDE 01 - A **/
            let scrollArr = (module == 'Movie') ? ['Scroll', 'Fixed'] : ['Scroll', 'Fixed', 'SCover', 'FCover', 'Left', 'Right', 'Repeat', 'Mixed'];
            let groupScro = this.modalGroup(TFieldType.ftSheet, 'Style',       rootname, module + 'd', 'Scroll', blockedx, scrollArr);
            let groupOpct = this.modalGroup(TFieldType.ftSheet, 'Opacy',       rootname, module + 'd', 'Opacit', blockedx, ['100%', '90%', '80%', '70%', '60%', '50%', '40%', '30%', '20%', '10%']);
            let groupChec = this.modalGroup(TFieldType.ftCheck, 'Filter gray', rootname, module + 'd', 'Grayed', blockedx, null);
            let groupAdju = this.modalGroup(TFieldType.ftCheck, 'Adjust',      rootname, module + 'd', 'Adjust', blockedx, null);
            let groupFile = this.modalGroup(TFieldType.ftFile,  'File',        rootname, module + 'd', 'Source', blockedx, null, {min: 0, max: 1, pos: 0});

            let slides = [];
            slides.push(groupScro);
            slides.push(groupOpct);
            slides.push(groupChec);
            slides.push(groupAdju);
            if (action == null) slides.push(groupFile);

            let slideFile = this.config.modalSlide(THotpageContent[blockedx.Content].slice(2, 99) + ' ' + module, null, null, null, 'CorRoxa', slides);
            this.util.modalopen(ModalFieldPage, 'quad', false, {module: module, slides: [slideFile], onOkiy: onOkiy}).subscribe();
        }

        if (module == 'Space') {
            let onOkiy = (that, okiy, index, isLast) => {

                let estilo = okiy[0].groups[0].fields[0].value;
                let height = okiy[0].groups[1].fields[0].value;

                blockedx[rootname].Estilo = this.platesaveed(blockedx, rootname, 'Estilo', null, 0, estilo);
                blockedx[rootname].Height = this.platesaveed(blockedx, rootname, 'Height', null, 0, (height == 'None' ? 0 : parseInt(height)));
                this.brandedSave(that);
            };

            let arrey = ['None', '1px', '2px', '3px', '4px'];
            for(var i = 5; i <= 200; i = i + 5) arrey.push(i + 'px');

            /** SLIDE 01 **/
            let groupSepa = this.modalGroup(TFieldType.ftRadio, 'Corte', rootname, 'Estilo',  null, blockedx, ['Square', 'Cropel', 'Croper']);
            let groupSize = this.modalGroup(TFieldType.ftSheet, 'Size',  rootname, 'Height',  null, blockedx, arrey);
            let slideSepa = this.config.modalSlide(THotpageContent[blockedx.Content].slice(2, 99) + ' ' + rootname, null, null, null, 'CorRoxa', [groupSepa, groupSize]);
            this.util.modalopen(ModalFieldPage, 'quad', false, {module: module, slides: [slideSepa], onOkiy: onOkiy}).subscribe();
        }

        if (module == 'Botao') {
            let onOkiy = (that, okiy, index, isLast) => {
                blockedx[rootname].Fill   = this.platesaveed(blockedx, rootname, 'Fill',  null, 0, okiy[0].groups[0].fields[0].value);
                blockedx[rootname].Size   = this.platesaveed(blockedx, rootname, 'Size',  null, 0, okiy[0].groups[1].fields[0].value);
                blockedx[rootname].Shape  = this.platesaveed(blockedx, rootname, 'Shape', null, 0, okiy[0].groups[2].fields[0].value);
                blockedx[rootname].Clip   = this.platesaveed(blockedx, rootname, 'Clip',  null, 0, okiy[0].groups[3].fields[0].value);
                this.brandedSave(that);
            };

            /** SLIDE 01 **/
            let groupFill = this.modalGroup(TFieldType.ftRadio, 'Style', rootname, 'Fill',  null, blockedx, ['Outline', 'Solid', 'Clear']);
            let groupSize = this.modalGroup(TFieldType.ftRadio, 'Sized', rootname, 'Size',  null, blockedx, ['Default', 'Small', 'Large']);
            let groupShap = this.modalGroup(TFieldType.ftRadio, 'Shape', rootname, 'Shape', null, blockedx, ['Square', 'Round']);
            let groupClip = this.modalGroup(TFieldType.ftPutin, 'Corte', rootname, 'Clip',  null, blockedx, ['TL', 'TR', 'BL', 'BR']);
            let slideFill = this.config.modalSlide(THotpageContent[blockedx.Content].slice(2, 99) + ' ' + rootname, null, null, null, 'CorRoxa', [groupFill, groupSize, groupShap, groupClip]);
            this.util.modalopen(ModalFieldPage, 'quad', false, {module: module, slides: [slideFill], onOkiy: onOkiy}).subscribe();
        }

        if (module == 'Fonte') {
            let onOkiy = (that, okiy, index, isLast) => {
                blockedx[rootname].Fonted = this.platesaveed(blockedx, rootname, 'Fonted', null, 0, okiy[0].groups[0].fields[0].value);
                blockedx[rootname].Weight = this.platesaveed(blockedx, rootname, 'Weight', null, 0, okiy[0].groups[1].fields[0].value);
                this.brandedSave(that);
            };

            /** SLIDE 01 **/
            let groupFont = this.modalGroup(TFieldType.ftRadio, 'Font', rootname, 'Fonted',  null, blockedx, ['Gotham', 'Brushstrike', 'Chunkfive', 'Rosmatika', 'Khotijah', 'Caliyan']);
            let groupWeig = this.modalGroup(TFieldType.ftRadio, 'Peso', rootname, 'Weight',  null, blockedx, [100, 200, 400, 500, 600, 900]);
            let slideFont = this.config.modalSlide(THotpageContent[blockedx.Content].slice(2, 99) + ' ' + rootname, null, null, null, 'CorRoxa', [groupFont, groupWeig]);
            this.util.modalopen(ModalFieldPage, 'quad', false, {module: module, slides: [slideFont], onOkiy: onOkiy}).subscribe();
        }

        if (module == 'Color') {
            let onOkiy = (that, okiy, index, isLast) => {

                if (this.util.slideNext(that, (index < okiy.length -1))) return;

                blockedx[rootname].Corone = this.platesaveed(blockedx, rootname, 'Corone', null, 0, okiy[0].groups[0].fields[0].value);
                blockedx[rootname].Cortwo = this.platesaveed(blockedx, rootname, 'Cortwo', null, 0, okiy[1].groups[0].fields[0].value);
                this.brandedSave(that);
            };

            /** COLOR **/
            let colorList: any[] = [];
            for (let color in this.config.colors) colorList.push({title: color, value: color});

            /** SLIDE 01 **/
            let groupCora = this.modalGroup(TFieldType.ftColor, null, rootname, 'Corone',  null, blockedx, colorList);
            let slideCora = this.config.modalSlide(THotpageContent[blockedx.Content].slice(2, 99), 'Vamos pintar?', 'Selecione uma cor!', 'b-icon-brush', 'CorRoxa', [groupCora]);

            /** SLIDE 01 **/
            let groupCorb = this.modalGroup(TFieldType.ftColor, null, rootname, 'Cortwo',  null, blockedx, colorList);
            let slideCorb = this.config.modalSlide(THotpageContent[blockedx.Content].slice(2, 99), 'Vamos pintar?', 'Selecione uma cor!', 'b-icon-brush', 'CorRoxa', [groupCorb]);

            this.util.modalopen(ModalFieldPage, 'quad', false, {module: module, slides: [slideCora, slideCorb], onOkiy: onOkiy}).subscribe();
        }

        if (module == 'Texto') {
            let onOkiy = (that, okiy, index, isLast) => {
                blockedx.Header.Textod = this.platesaveed(blockedx, 'Header', 'Textod', null, 0, okiy[0].groups[0].fields[0].value);
                blockedx.Resume.Textod = this.platesaveed(blockedx, 'Resume', 'Textod', null, 0, okiy[0].groups[1].fields[0].value);
                blockedx.Button.Textod = this.platesaveed(blockedx, 'Button', 'Textod', null, 0, okiy[0].groups[2].fields[0].value);
                this.brandedSave(that);
            };

            /** OPEN **/
            let groupHead = this.modalGroup(TFieldType.ftLine, 'Titulo', 'Header', 'Textod',  null, blockedx, null, {min: 0, max: 15, pos: 0});
            let groupResu = this.modalGroup(TFieldType.ftLine, 'Resumo', 'Resume', 'Textod',  null, blockedx, null, {min: 0, max: 30, pos: 0});
            let groupButt = this.modalGroup(TFieldType.ftLine, 'Button', 'Button', 'Textod',  null, blockedx, null, {min: 0, max: 30, pos: 0});

            /** INFO **/
            let fieldInfo = this.config.modalField(TFieldType.ftInfo, null, '%ProfileShow%, %MusicalCoin%, %BrandedNome%, %BrandedShow%.', null, 'Utilize as <b>Tags</b> para definir valor.', null, null);
            let groupInfo = this.config.modalGroup(null, [fieldInfo]);

            let slideText = this.config.modalSlide(THotpageContent[blockedx.Content].slice(2, 99) + ' ' + rootname, null, null, null, 'CorRoxa', [groupHead, groupResu, groupButt, groupInfo]);
            this.util.modalopen(ModalFieldPage, 'quad', false, {slides: [slideText], onOkiy: onOkiy}).subscribe();
        }

        if (module == 'Molde') {

            if (action == '#Hide' || action == '#Symb') {
                blockedx[rootname].Molded = (action == '#Symb' ? null : {Padtop: 0, Padbot: 0, Sizing: 0, Source: action, B64: null});
                this.brandedSave();
                return;
            }

            let onOkiy = (that, okiy, index, isLast) => {
                if (this.util.slideNext(that, (index < okiy.length -1))) return;
                let source = this.config.paths.httpStorage + '/hotpage/' + this.copybran.BrandedID + '/' + THotpageContent[blockedx.Content] + '.png';
                let file64 = okiy[0].groups[0].fields[0].value.base64;
                let sizing = parseInt(okiy[0].groups[1].fields[0].value);
                let padtop = parseInt(okiy[0].groups[2].fields[0].value);
                let padbot = parseInt(okiy[0].groups[3].fields[0].value);
                let base64 = (!file64 ? null : file64.indexOf(',') < 0 ? null : file64.split(',')[1]);
                let object = {Padtop: padtop, Padbot: padbot, Sizing: sizing, Source: source, B64: base64};

                blockedx[rootname].Molded = object;

                this.brandedSave(that);
            };

            let arrey = ['60px', '80px', '100px', '120px', '140px', '160px', '180px', '200px'];

            let arroy = [];
            for (let i = 0; i <= 200; i++) arroy.push(i + 'px');

            
            /** SLIDE 01 - A **/
            let groupFile = this.modalGroup(TFieldType.ftFile,   'File',  rootname, module + 'd',  'Source', blockedx, null, {min: 0, max: 1, pos: 0});
            let groupSize = this.modalGroup(TFieldType.ftSheet,  'Size',  rootname, module + 'd',  'Sizing', blockedx, arrey);
            let groupPtop = this.modalGroup(TFieldType.ftPicker, 'PTop',  rootname, module + 'd',  'Padtop', blockedx, arroy);
            let groupPbot = this.modalGroup(TFieldType.ftPicker, 'PBot',  rootname, module + 'd',  'Padbot', blockedx, arroy);

            let slides = [];
            slides.push(groupFile);
            slides.push(groupSize);
            slides.push(groupPtop);
            slides.push(groupPbot);

            let slideFile = this.config.modalSlide(THotpageContent[blockedx.Content].slice(2, 99) + ' ' + module, null, null, null, 'CorRoxa', slides);
            this.util.modalopen(ModalFieldPage, 'quad', false, {module: module, slides: [slideFile], onOkiy: onOkiy}).subscribe();
        }

        if (module == 'Delet') {
            blockedx.Header.Textod = null;
            blockedx.Resume.Textod = null;
            blockedx.Button.Textod = null;
            this.brandedSave(null);
        }

    }

    platesaveed(blocked, rootname: 'Header' | 'Resume' | 'Button' | 'Spacer' | 'Ground', rootnome: 'Corone' | 'Cortwo' | 'Fonted' | 'Weight' | 'Textod' | 'Molded' | 'Fill' | 'Size' | 'Clip' | 'Shape' | 'Estilo' | 'Height' | 'Imaged' | 'Movied', rootfile: 'Source' | 'Opacit' | 'Scroll' | ' Grayed' = null, tag: number = 0, value: any): string {

        let plate = this.config.plateobject(blocked.Content);

        let plateddy = plate[rootname][rootnome];
        //let blockedy = blocked[rootname][rootnome];

        let result = null;
        let based = (plateddy + '').trim().toLowerCase();
        let saved = (value    + '').trim().toLowerCase();
        if (saved && saved != based) result = value;

        //let text = (rootnome == 'Textod');
        //let file = (rootnome == 'Imaged' || rootnome == 'Movied');
        //let full = (!text && !file);

        //if (full) result = (blockedy != null ? blockedy           : plateddy);
        //if (text) result = (blockedy != null ? blockedy           : plateddy[blocked.Content][tag]);
        //if (file) result = (blockedy != null ? blockedy[rootfile] : (!plateddy ? null : plateddy[rootfile]));

        //rootnome == 'Corone' || 'Cortwo'
        if (result == this.copybran.BrandedCora) result = '#Corone';
        return result;

    }

    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/branded-html/branded-html.ts